import { AGeneralActionCreator } from '@ispm/core/classes/general-action-creator.abstract';

export enum NAVIGATION_ACTIONS  {
  SET_WEB_CONFIG = '[NAVIGATION] SET WEBCONFIG',
  SET_MENU_STATE = '[NAVIGATION] SET MENU STATE',
  NAVIGATION_CLEAN_UP = '[NAVIGATION] Navigation Clear State',
  SET_CURRENT_APP = '[NAVIGATION] SET CURRENT APP',
  SET_CURRENT_APP_SELECTED_TAB = '[NAVIGATION] SET CURRENT APP SELECTED TAB'
}

export class NavigationCleanUpAction extends AGeneralActionCreator {
  readonly type = NAVIGATION_ACTIONS.NAVIGATION_CLEAN_UP;

  constructor() {
    super(null);
  }
}

